import { ref } from 'vue';
import axiosClient from '@/axiosClient';
import { API_ENDPOINTS } from '@/apiConfig';

export function useFetchNotlogoutEmployees() {
    const data = ref(null);
    const error = ref(null);
    const loading = ref(false);

    async function fetchNotlogoutEmployees() {
        loading.value = true;
        try {
            const response = await axiosClient.get(API_ENDPOINTS.fetchNotlogoutEmployees);
            data.value = response.data;
        } catch (err) {
            console.error('Error fetching not logout employees:', err);
            error.value = 'Failed to fetch employees';
            if (axiosClient.isAxiosError(err)) {
                if (err.response) {
                    console.error('Error response:', err.response.data);
                    console.error('Error status:', err.response.status);
                    error.value = `Server error: ${err.response.status}`;
                } else if (err.request) {
                    console.error('Error request:', err.request);
                    error.value = 'No response from server';
                } else {
                    console.error('Error message:', err.message);
                    error.value = err.message;
                }
            }
        } finally {
            loading.value = false;
        }
    }

    return { data, error, loading, fetchNotlogoutEmployees };
}